import React, { Component } from 'react'

class About extends Component {
  render () { return (<div />) }
}

export default About
